import {
  Box,
  Button,
  Popover,
  StatusIndicator,
} from "@amzn/awsui-components-react";
import { trackButtonClick, Feature } from "../telemetry/telemetry";
import { CopyToClipboard } from "../../util/browserUtils";
import { useScrollDismissKey } from "../../util/useScrollDismissKey";
import React from "react";

export default (props: { asin: string; componentName: Feature }) => {
  const { key: popoverKey, arm: armPopover } = useScrollDismissKey();

  return (
    <div>
      <Box float="left">
        <Popover
          key={popoverKey}
          size="small"
          // `bottom` + portal: opens the "ASIN copied" bubble below
          // the trigger, and `renderWithPortal` moves the panel to
          // Cloudscape's overlay layer so it isn't trapped inside
          // the sticky ASIN column's stacking context or clipped
          // by the sticky table header on the first visible row.
          //
          // `popoverKey` from `useScrollDismissKey` remounts the
          // popover on the first scroll after a click, closing it
          // before the (position-fixed) panel drifts out of place.
          position="bottom"
          triggerType="custom"
          dismissButton={false}
          renderWithPortal
          content={
            <StatusIndicator type="success">ASIN copied</StatusIndicator>
          }
        >
          <Button
            iconName={"copy"}
            children={"Copy"}
            variant={"icon"}
            onClick={() => {
              armPopover();
              trackButtonClick(props.componentName, "copyAsin", {
                asin: props.asin,
              });
              CopyToClipboard(props.asin);
            }}
          />
        </Popover>
      </Box>
    </div>
  );
};
